import Avatar from 'react-avatar';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import Badge from "../../components/Badge";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";
import {Link} from "react-router-dom";

const refundStatusBadgeMap = {
    'PENDING':   'badge badge-light-warning',
    'FAILED':    'badge badge-light-danger',
    'CREATED':   'badge badge-light-info',
    'PROCESSED': 'badge badge-light-success',
};

const refundTypeBadgeMap = {
    'FULL':           'badge badge-light-primary',
    'PARTIAL':        'badge badge-light-warning',
    'PARTIAL_CUSTOM': 'badge badge-light-info',
};

function Refund({refund}) {
    const [detailsModal, setDetailsModal] = useState(false);
    const detailsModalToggle = () => setDetailsModal(!detailsModal);

    const orderNumber = refund.order_number || '-';
    const orderId = refund.order || null;
    const customerEmail = refund.order?.customer?.email || null;

    return (
        <>
            <tr>
                <td className="invoice-pointer text-primary" onClick={detailsModalToggle}>
                    <Link to="#" className="text-primary">
                        {refund.id}
                    </Link>
                </td>
                <td>{orderNumber}</td>
                <td>
                    <span className={refundTypeBadgeMap[refund.refund_type] || 'badge badge-light-secondary'}>
                        {refund.refund_type || '-'}
                    </span>
                </td>
                <td>
                    <Badge
                        badge={refundStatusBadgeMap[refund.refund_status] || 'badge badge-light-secondary'}
                        status={refund.refund_status}
                    />
                </td>
                <td>{refund.currency || 'INR'} {refund.amount}</td>
                <td>{new Date(refund.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
            </tr>

            <Modal className="modal-xl" isOpen={detailsModal} toggle={detailsModalToggle}>
                <ModalHeader
                    toggle={detailsModalToggle}
                    close={
                        <button className="close" onClick={detailsModalToggle}>
                            &times;
                        </button>
                    }
                >
                    Refund Details
                </ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <p className="sub-header">
                            <Avatar size={95} name={customerEmail || orderNumber} round />
                        </p>

                        <div className="table-responsive">
                            <table className="table mb-0">
                                <tbody>

                                {/* ── Identifiers ── */}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Refund ID</td>
                                    <td>{refund.id}</td>
                                </tr>
                                {refund.reference_refund_id && (
                                    <tr>
                                        <th scope="row"> </th>
                                        <td>Reference Refund ID</td>
                                        <td>{refund.reference_refund_id}</td>
                                    </tr>
                                )}

                                {/* ── Order ── */}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Order Number</td>
                                    <td>{orderNumber}</td>
                                </tr>
                                {orderId && (
                                    <tr>
                                        <th scope="row"> </th>
                                        <td>Order ID</td>
                                        <td>{orderId}</td>
                                    </tr>
                                )}
                                {customerEmail && (
                                    <tr>
                                        <th scope="row"> </th>
                                        <td>Customer Email</td>
                                        <td>{customerEmail}</td>
                                    </tr>
                                )}

                                {/* ── Type ── */}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Refund Type</td>
                                    <td>
                                        <span className={refundTypeBadgeMap[refund.refund_type] || 'badge badge-light-secondary'}>
                                            {refund.refund_type || '-'}
                                        </span>
                                    </td>
                                </tr>

                                {/* ── Status ── */}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Status</td>
                                    <td>
                                        <Badge
                                            badge={refundStatusBadgeMap[refund.refund_status] || 'badge badge-light-secondary'}
                                            status={refund.refund_status}
                                        />
                                    </td>
                                </tr>

                                {/* ── Financials ── */}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Amount</td>
                                    <td>{refund.currency || 'INR'} {refund.amount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Currency</td>
                                    <td>{refund.currency || <NoneValue />}</td>
                                </tr>

                                {/* ── Reason ── */}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Refund Reason</td>
                                    <td>{refund.refund_reason || <NoneValue />}</td>
                                </tr>

                                {/* ── Timestamps ── */}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Created</td>
                                    <td>{new Date(refund.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Updated</td>
                                    <td>{new Date(refund.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}

export default Refund;
